(function($) {

  $('.icon-tabs li').on('click', function() {
    if (!$(this).hasClass('vc_active')) {
      var href = $(this).find('a').attr('href');
      var path = window.location.pathname;
      history.pushState(null, null, path + href);
      $(this).siblings('.vc_tta-tab').removeClass('vc_active');
      $(this).addClass('vc_active');

      $(this).closest('.vc_tta-container').find('.vc_tta-panel').removeClass('vc_active');
      $(this).closest('.vc_tta-container').find(href).addClass('vc_active');
    }
    
  });

}(jQuery))